var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { Box, Text } from '../..';
import { jsx } from 'theme-ui';
export default function Scale(_a) {
    var { text, value, max = 4 } = _a, rest = __rest(_a, ["text", "value", "max"]);
    if (value == null)
        return null;
    const values = new Array(max).fill(0).map((_, index) => index + 1);
    return (jsx(Box, Object.assign({ sx: { marginBottom: 3 } }, rest),
        jsx(Text, null, text),
        jsx(Box, { sx: { display: 'flex' } }, values.map((scale) => (jsx(Box, { key: scale, sx: {
                width: `${100 / max}%`,
                height: 5,
                backgroundColor: scale <= value ? 'primary' : 'borderSecondary',
                marginTop: 2,
                marginRight: '2px',
                marginBottom: '9px',
                boxSizing: 'border-box',
            } }))))));
}
//# sourceMappingURL=Scale.js.map